import gql from 'graphql-tag'

export const fetchGlasswareOrdersQuery = gql`
  query (
  $currentPage: Int,
  $pageSize: Int = 100,
  $filter: CustomerOrdersFilterInput,
  $sort: CustomerOrderSortInput
  ) {
  customer {
    orders (
      pageSize: $pageSize
      currentPage: $currentPage
      filter: $filter
      sort: $sort
    ) {
      items {
        order_date
        order_number
        id
        created_at
        grand_total
        status
        carrier
        total_cost
        delivery_cost
        gross_value
        items {
        product_image
        product_name
        number_of_items_in_box
        total_your_price_tax
        product_sku
        quantity_ordered
        }
        additional_data {
          delivery_date
          delivery_message
          empty_return
          ship_to_name
          total_empties_deposit
          total_your_price
          customer_order_number
          payment_method
          total_your_price_tax
          total_your_price_empty_deposit
          type_of_transport
          delivery_on_pallet
          delivery_after_six_pm
          delivery_message
          ship_to
          custom_email
          __typename
          }
          shipping_address {
          firstname
          lastname
          middlename
          region
          region_id
          country_code
          street
          company
          telephone
          fax
          postcode
          city
          prefix
          suffix
          vat_id
          __typename
          }
          billing_address {
          firstname
          lastname
          middlename
          region
          region_id
          country_code
          __typename
          }
          __typename
          }
          page_info {
          page_size
          current_page
          total_pages
          }
          __typename
          total_count
          }
          __typename
          }
          }
          
`

// export const fetchPendingOrdersDetailQuery = gql`
//   query ($cart_id: String!) {
//     getPreOrderDetails(cart_id: $cart_id, pre_order: true) {
//       email
//       transporttype
//       ship_to_id
//       delivery_date
//       id
//       grand_total_your_price_tax
//       grand_total_your_price
//       pre_order
//       sap_order_type
//       billing_address {
//         city
//         country {
//           code
//           label
//         }
//         firstname
//         lastname
//         postcode
//         region {
//           code
//           label
//         }
//         street
//         telephone
//       }
//       shipping_addresses {
//         firstname
//         lastname
//         street
//         city
//         region {
//           code
//           label
//         }
//         country {
//           code
//           label
//         }
//         telephone
//         available_shipping_methods {
//           amount {
//             currency
//             value
//           }
//           available
//           carrier_code
//           carrier_title
//           error_message
//           method_code
//           method_title
//           price_excl_tax {
//             value
//             currency
//           }
//           price_incl_tax {
//             value
//             currency
//           }
//         }
//         selected_shipping_method {
//           amount {
//             value
//             currency
//           }
//           carrier_code
//           carrier_title
//           method_code
//           method_title
//         }
//       }
//       items {
//       ... on CartItemInterface {
//           product {
//             number_of_products_on_layer
//             number_of_items_on_pallet
//             number_of_layers_per_pallet
//             name
//             sku
//             volume
//             small_image {
//               url
//             }
//           }
//           quantity
//           prices {
//             your_price
//             your_price_tax
//             total_your_price_tax
//           }
//           errors {
//             code
//             message
//           }
//         }
//         ... on SimpleCartItem {
//           quantity_total
//           number_of_packages
//           number_of_layer
//           number_of_layer_total
//           number_of_pallet

//         }
//       }
//       selected_payment_method {
//         code
//         title
//       }
//       prices {
//         grand_total {
//           value
//           currency
//         }
//       }
//     }
//   }
// `
